import { Icon as BlueIcon } from '@blueprintjs/core';

import { Container, Count, Icon, Text } from './QuantityCounter.styles';

interface OwnProps {
  count: number;
  setCount: (n: number) => void;
  disabled?: boolean;
}

export const QuantityCounter = ({ count, setCount, disabled }: OwnProps) => {
  const allowMinus = count > 1 && !disabled;

  const allowPlus = count < 99 && !disabled;

  const callMinus = () => {
    if (allowMinus) {
      setCount(count - 1);
    }
  };

  const callPlus = () => {
    if (allowPlus) {
      setCount(count + 1);
    }
  };

  return (
    <Container>
      <Text disabled={disabled}>Quantity</Text>
      <Icon onClick={callMinus} disabled={disabled}>
        <BlueIcon
          icon="small-minus"
          color={allowMinus ? '#8F95B2' : '#D8DAE5'}
        />
      </Icon>
      <Count disabled={disabled}>{count}</Count>
      <Icon onClick={callPlus} disabled={disabled}>
        <BlueIcon icon="small-plus" color={allowPlus ? '#8F95B2' : '#D8DAE5'} />
      </Icon>
    </Container>
  );
};
